export default {
  units: (state) => {
    return state.units;
  },

  unitCode: (state) => {
    return state.unitCode;
  },

  wareCategories: (state) => {
    return state.wareCategories;
  },

  wareCategoryCode: (state) => {
    return state.wareCategoryCode;
  },

  wares: (state) => {
    return state.wares;
  },
  ware: (state) => {
    return state.ware;
  },

  wareCode: (state) => {
    return state.wareCode;
  },

  commodityCategories: (state) => {
    return state.commodityCategories;
  },

  commodityCategoryCode: (state) => {
    return state.commodityCategoryCode;
  },

  commodities: (state) => {
    return state.commodities;
  },
  commoditiesTotalCount: (state) => {
    return state.commoditiesTotalCount;
  },
  commodity: (state) => {
    return state.commodity;
  },

  commodityCode: (state) => {
    return state.commodityCode;
  },

  commodityInfo: (state) => {
    return state.commodityInfo;
  },

  commodityNavigation: (state) => {
    return state.commodityNavigation;
  },

  commodityBySearch: (state) => {
    return state.commodityBySearch;
  },

  shelfs: (state) => {
    return state.shelfs;
  },

  shelfCode: (state) => {
    return state.shelfCode;
  },

  unitCoefficients: (state) => {
    return state.unitCoefficients;
  },

  commodityBarcodes: (state) => {
    return state.commodityBarcodes;
  },

  commodityUnitCounts: (state) => {
    return state.commodityUnitCounts;
  },

  commodityImages: (state) => {
    return state.commodityImages;
  },

  commodityAttachments: (state) => {
    return state.commodityAttachments;
  },
  commodityAttachment: (state) => {
    return state.commodityAttachment;
  },

  commodityFeatures: (state) => {
    return state.commodityFeatures;
  },

  commodityFeatureCode: (state) => {
    return state.commodityFeatureCode;
  },

  wareVoucherTypes: (state) => {
    return state.wareVoucherTypes;
  },
  wareVoucherType: (state) => {
    return state.wareVoucherType;
  },

  wareVoucherTypeCode: (state) => {
    return state.wareVoucherTypeCode;
  },

  additionalCommodityParameters: (state) => {
    return state.additionalCommodityParameters;
  },

  parameterValues: (state) => {
    return state.parameterValues;
  },

  tempReceipts: (state) => {
    return state.tempReceipts;
  },
  tempReceipt: (state) => {
    return state.tempReceipt;
  },
  tempReceiptId: (state) => {
    return state.tempReceiptId;
  },
  tempReceiptCreateResult: (state) => {
    return state.tempReceiptCreateResult;
  },

  tempReceiptCode: (state) => {
    return state.tempReceiptCode;
  },

  tempReceiptSerial: (state) => {
    return state.tempReceiptSerial;
  },

  tempReceiptNavigation: (state) => {
    return state.tempReceiptNavigation;
  },

  tempReceiptCartable: (state) => {
    return state.tempReceiptCartable;
  },

  tempReceiptExitCartable: (state) => {
    return state.tempReceiptExitCartable;
  },

  receipts: (state) => {
    return state.receipts;
  },
  receipt: (state) => {
    return state.receipt;
  },

  receiptCode: (state) => {
    return state.receiptCode;
  },

  receiptSerial: (state) => {
    return state.receiptSerial;
  },

  receiptNavigation: (state) => {
    return state.receiptNavigation;
  },

  receiptCheckDelete: (state) => {
    return state.receiptCheckDelete;
  },

  receiptCheckUpdate: (state) => {
    return state.receiptCheckUpdate;
  },

  receiptVoucher: (state) => {
    return state.receiptVoucher;
  },

  receiptAttachments: (state) => {
    return state.receiptAttachments;
  },

  readBuyRequestByCode: (state) => {
    state.readBuyRequestByCode.forEach(func);
    function func(item) {
      item.subUnitCount = item.subCount;
      item.buyRequestTitle = item.reqBuyCode;
      item.totalCount = item.remain;
      item.mainCount = item.remain;
    }
    return state.readBuyRequestByCode;
  },

  readBuyRequestByCommodityOptions: (state) => {
    const readBuyRequestByCommodityOptions = [];
    state.readBuyRequestByCommodity.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.buyRequestId,
        text: item.reqBuyCode,
        dateLocal: item.dateLocal,
        remain: item.remain,
        confirmTotalCount: item.confirmTotalCount,
        buyFactorWithoutReceiptTotalCount:
          item.buyFactorWithoutReceiptTotalCount,
      };
      readBuyRequestByCommodityOptions.push(pushItem);
    }
    return readBuyRequestByCommodityOptions;
  },

  receiptByBarcode: (state) => {
    return state.receiptByBarcode;
  },

  receiptId: (state) => {
    return state.receiptId;
  },
  receiptCreateResult: (state) => {
    return state.receiptCreateResult;
  },

  receiptManagementCartable: (state) => {
    return state.receiptManagementCartable;
  },

  drafts: (state) => {
    return state.drafts;
  },
  draft: (state) => {
    return state.draft;
  },
  draftId: (state) => {
    return state.draftId;
  },
  draftCreateResult: (state) => {
    return state.draftCreateResult;
  },

  draftCode: (state) => {
    return state.draftCode;
  },

  draftSerial: (state) => {
    return state.draftSerial;
  },

  draftNavigation: (state) => {
    return state.draftNavigation;
  },

  draftCheckCreate: (state) => {
    return state.draftCheckCreate;
  },

  draftCheckUpdate: (state) => {
    return state.draftCheckUpdate;
  },

  draftVoucher: (state) => {
    return state.draftVoucher;
  },

  readDraftRequestByCode: (state) => {
    state.readDraftRequestByCode.forEach(func);
    function func(item) {
      item.subUnitCount = item.subCount;
      item.totalCount = item.remain ?? item.totalCount;
      item.mainCount = item.remain ?? item.mainCount;
    }
    return state.readDraftRequestByCode;
  },

  draftAttachments: (state) => {
    return state.draftAttachments;
  },

  draftRequests: (state) => {
    return state.draftRequests;
  },
  draftRequest: (state) => {
    return state.draftRequest;
  },
  draftRequestId: (state) => {
    return state.draftRequestId;
  },
  draftRequestCreateResult: (state) => {
    return state.draftRequestCreateResult;
  },

  draftRequestCode: (state) => {
    return state.draftRequestCode;
  },

  draftRequestSerial: (state) => {
    return state.draftRequestSerial;
  },

  draftRequestNavigation: (state) => {
    return state.draftRequestNavigation;
  },

  draftRequestCartable: (state) => {
    state.draftRequestCartable.forEach(func);
    function func(item) {
      if (item.draftRequestCommodityBatchId) {
        item.confirmTotalCount = 1;
      }
    }
    return state.draftRequestCartable;
  },

  draftRequestCheckCreate: (state) => {
    return state.draftRequestCheckCreate;
  },

  draftRequestCheckUpdate: (state) => {
    return state.draftRequestCheckUpdate;
  },

  receiptCartable: (state) => {
    return state.receiptCartable;
  },

  draftCartable: (state) => {
    return state.draftCartable;
  },

  draftManagementCartable: (state) => {
    return state.draftManagementCartable;
  },

  numeralCirculation: (state) => {
    return state.numeralCirculation;
  },
  rialCirculation: (state) => {
    return state.rialCirculation;
  },

  numeralCardex: (state) => {
    return state.numeralCardex;
  },
  rialCardex: (state) => {
    return state.rialCardex;
  },
  circulationCommodity: (state) => {
    return state.circulationCommodity;
  },

  receiptConfirmCartable: (state) => {
    return state.receiptConfirmCartable;
  },

  receiptUnConfirmCartable: (state) => {
    return state.receiptUnConfirmCartable;
  },

  draftConfirmCartable: (state) => {
    return state.draftConfirmCartable;
  },

  draftValue: (state) => {
    return state.draftValue;
  },

  draftUnConfirmCartable: (state) => {
    return state.draftUnConfirmCartable;
  },

  inventoryDeduction: (state) => {
    return state.inventoryDeduction;
  },

  inventorySummary: (state) => {
    return state.inventorySummary;
  },
  inventorySummaryDetail: (state) => {
    return state.inventorySummaryDetail;
  },

  commoditySleep: (state) => {
    return state.commoditySleep;
  },

  commodityCirculation: (state) => {
    return state.commodityCirculation;
  },

  negativeCommodity: (state) => {
    return state.negativeCommodity;
  },

  sortReceipt: (state) => {
    return state.sortReceipt;
  },

  transferCommodities: (state) => {
    return state.transferCommodities;
  },
  transferCommodity: (state) => {
    return state.transferCommodity;
  },

  transferCommodityCode: (state) => {
    return state.transferCommodityCode;
  },

  transferCommodityCartable: (state) => {
    return state.transferCommodityCartable;
  },

  wareDocument: (state) => {
    return state.wareDocument;
  },
  wareFinancialDocument: (state) => {
    return state.wareFinancialDocument;
  },

  numeralInventory: (state) => {
    return state.numeralInventory;
  },
  rialInventory: (state) => {
    return state.rialInventory;
  },

  warehousings: (state) => {
    return state.warehousings;
  },
  warehousing: (state) => {
    return state.warehousing;
  },

  warehousingId: (state) => {
    return state.warehousingId;
  },
  warehousingCreateResult: (state) => {
    return state.warehousingCreateResult;
  },

  warehousingCommodities: (state) => {
    return state.warehousingCommodities;
  },

  warehousingContradictions: (state) => {
    return state.warehousingContradictions;
  },

  warehousingTag: (state) => {
    return state.warehousingTag;
  },

  warehousingCommodityByWare: (state) => {
    return state.warehousingCommodityByWare;
  },

  warehousingCommodityByWareOptions: (state) => {
    const warehousingCommodityByWareOptions = [];
    state.warehousingCommodityByWare.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        // متن نمایشیِ فیلد کالا بعد از انتخاب: کد کالا | نام کالا | واحد شمارش
        fullText: item.code + " | " + item.title + " | " + item.unitCountTitle,
        code: item.code,
        unitCountId: item.unitCountId,
        unitCountTitle: item.unitCountTitle,
      };
      warehousingCommodityByWareOptions.push(pushItem);
    }
    return warehousingCommodityByWareOptions;
  },

  warehousingCommodityBatches: (state) => {
    return state.warehousingCommodityBatches;
  },

  commodityBatches: (state) => {
    return state.commodityBatches;
  },

  userLimitWares: (state) => {
    return state.userLimitWares;
  },

  reqBuys: (state) => {
    return state.reqBuys;
  },
  reqBuy: (state) => {
    return state.reqBuy;
  },
  reqBuyId: (state) => {
    return state.reqBuyId;
  },
  reqBuyCreateResult: (state) => {
    return state.reqBuyCreateResult;
  },

  reqBuyCode: (state) => {
    return state.reqBuyCode;
  },

  reqBuyNavigation: (state) => {
    return state.reqBuyNavigation;
  },

  notYetBuyers: (state) => {
    return state.notYetBuyers;
  },

  reqBuyCartable: (state) => {
    return state.reqBuyCartable;
  },

  packageTypes: (state) => {
    return state.packageTypes;
  },

  packageTypeCode: (state) => {
    return state.packageTypeCode;
  },

  boms: (state) => {
    return state.boms;
  },
  bom: (state) => {
    return state.bom;
  },

  bomCode: (state) => {
    return state.bomCode;
  },

  bomCommodities: (state) => {
    return state.bomCommodities;
  },

  commodityInventoryWare: (state) => {
    return state.commodityInventoryWare;
  },

  receiptNotes: (state) => {
    return state.receiptNotes;
  },
  draftsNotes: (state) => {
    return state.draftsNotes;
  },

  buyTypes: (state) => {
    return state.buyTypes;
  },
  buyTypeCode: (state) => {
    return state.buyTypeCode;
  },

  receiptVerificationCartable: (state) => {
    return state.receiptVerificationCartable;
  },
  draftVerificationCartable: (state) => {
    return state.draftVerificationCartable;
  },

  settings: (state) => {
    return state.settings;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },

  printLink: (state) => {
    return state.printLink;
  },

  commodityGroupConfigs: (state) => {
    return state.commodityGroupConfigs;
  },

  services: (state) => {
    return state.services;
  },
  service: (state) => {
    return state.service;
  },
  serviceSerial: (state) => {
    return state.serviceSerial;
  },

  serviceGroups: (state) => {
    return state.serviceGroups;
  },
  serviceGroupCode: (state) => {
    return state.serviceGroupCode;
  },

  // Static Getters ---------------------------------------------------------------
  receiptActions() {
    return [
      {
        subItems: [{ value: 1, title: "حذف سند حسابداری" }],
      },
      // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
      // {
      //   subItems: [{ value: 3, title: "حذف فاکتور خرید" }],
      // },
      // {
      //   subItems: [{ value: 5, title: "حذف فاکتور مرجوعی فروش" }],
      // },
      {
        subItems: [{ value: 6, title: "غیرقطعی کردن رسید انبار" }],
      },
      {
        subItems: [{ value: 7, title: "بازخوانی از درخواست خرید" }],
      },
      {
        subItems: [{ value: 8, title: "کپی رسید" }],
      },
    ];
  },

  financialReceiptActions() {
    return [
      {
        subItems: [
          { value: 1, title: "صدور سند حسابداری" },
          { value: 2, title: "حذف سند حسابداری" },
        ],
      },
      {
        subItems: [
          { value: 3, title: "صدور فاکتور خرید" },
          // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
          // { value: 4, title: "حذف فاکتور خرید" },
        ],
      },
      {
        subItems: [
          { value: 5, title: "صدور فاکتور مرجوعی فروش" },
          // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
          // { value: 6, title: "حذف فاکتور مرجوعی فروش" },
        ],
      },
      {
        subItems: [{ value: 7, title: "غیرقطعی کردن رسید انبار" }],
      },
      {
        subItems: [{ value: 8, title: "بازخوانی از درخواست خرید" }],
      },
      {
        subItems: [{ value: 9, title: "کپی رسید" }],
      },
    ];
  },

  // حواله مقداری منوی عملیات نداشت؛ فعلا فقط گزینه غیرقطعی کردن دارد
  draftActions() {
    return [
      {
        subItems: [{ value: 1, title: "غیرقطعی کردن حواله انبار" }],
      },
    ];
  },

  financialDraftActions() {
    return [
      {
        subItems: [
          { value: 1, title: "صدور سند حسابداری" },
          { value: 2, title: "حذف سند حسابداری" },
        ],
      },
      {
        subItems: [
          { value: 3, title: "صدور فاکتور فروش" },
          // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
          // { value: 4, title: "حذف فاکتور فروش" },
        ],
      },
      {
        subItems: [
          { value: 5, title: "صدور فاکتور مرجوعی خرید" },
          // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
          // { value: 6, title: "حذف فاکتور مرجوعی خرید" },
        ],
      },
      {
        subItems: [{ value: 7, title: "غیرقطعی کردن حواله انبار" }],
      },
      {
        subItems: [{ value: 8, title: "بازخوانی از درخواست حواله" }],
      },
    ];
  },

  groupEditMenu() {
    return [
      {
        subItems: [{ value: 1, title: "سرفصل های کالا" }],
      },
      {
        subItems: [
          { value: 2, title: "فعال شدن کالاهای انتخابی در همه ی انبارها" },
        ],
      },
      {
        subItems: [
          { value: 3, title: "فعال شدن کالا به عنوان محصول" },
          { value: 4, title: "غیر فعال شدن کالا به عنوان محصول" },
        ],
      },
      {
        subItems: [
          { value: 5, title: "فعال شدن به عنوان مواد اولیه" },
          { value: 6, title: "غیر فعال شدن به عنوان مواد اولیه" },
        ],
      },
      {
        subItems: [
          { value: 7, title: "فعال شدن کالا" },
          { value: 8, title: "غیر فعال شدن کالا" },
        ],
      },
      // موقتا غیرفعال شده - طبق درخواست فعلا کامنت بماند (حذف نشود)
      // {
      //   subItems: [
      //     { value: 9, title: "فعال شدن کالا به عنوان کالای خدماتی" },
      //     { value: 10, title: "غیر فعال شدن کالا به عنوان کالای خدماتی" },
      //   ],
      // },
      {
        subItems: [{ value: 11, title: "تغییر گروهی شناسه یا نام مالیاتی" }],
      },
      {
        subItems: [
          {
            value: 12,
            title: "مرتب سازی و تغییر گروهی کد کالا براساس گروه کالا",
          },
        ],
      },
      {
        subItems: [{ value: 13, title: "تغییر گروهی پارامترهای تکمیلی کالا" }],
      },
      {
        subItems: [{ value: 14, title: "تعیین انبارهای کالاها به صورت گروهی" }],
      },
    ];
  },
  managementCartableOptions() {
    return [
      { value: 1, text: "بازگشت به مرحله قبل" },
      { value: 2, text: "ارسال به مرحله بعدی" },
      { value: 3, text: "ارسال به یک وضعیت خاص" },
      { value: 4, text: "رد همه درخواست‌ها" },
    ];
  },
};
